export const SHOW_CV_DOWNLOAD = false;

export const CV_DOWNLOAD_PATH = "/cv/jani-luostarinen-cv.pdf";
